<template>
  <footer class="footer">
    <div class="section bg--secondary">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <h2 class="h1 mb-25">BarnehageHMS</h2>
            <p class="h3">Verktøy for bedre jobbhelse</p>
          </div>
          <div class="col-md-6 d-flex flex-column justify-content-center">
            <p class="h3 no-pre">
              BarnehageHMS bruker informasjonskapsler for å gi deg
              en bedre brukeropplevelse.
            </p>
            <p class="no-pre">
              Se vår
              <a
                href="https://www.ks.no/om-ks/personvernerklaring/"
                target="_blank"
                rel="noopener"
              >personvernerklæring</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>